import React, {Component} from 'react'

import Registry from '../../../registry/index';

const GIFT_ANONIMITY_NOBODY = 2;
const GIFT_ANONIMITY_RECIPIENT = 1;
const GIFT_ANONIMITY_PUBLIC = 0;

class ChatLogItemGift extends Component {
    render() {
        let {message, currentUser} = this.props;
        
        if (message.anon === GIFT_ANONIMITY_RECIPIENT &&
            message.receiver === currentUser.nick && !message.sender
        ) return null;
        
        let lang = Registry.get('locale');

        let senderBlock = '';

        if (message.sender && message.senderProfileURL) {
            senderBlock = <a href={lang.path + message.senderProfileURL} target="_blank" className="sender">{message.sender}</a>
        } else {
            senderBlock = <span className="anonymous">{lang.gift_sender_anonymous}</span>
        }

        return (
            <div className="gift-notification">
                <div className="thumbnail">
                    <img src={message.image_url} alt=""/>
                </div>
                <div className="text">
                    {senderBlock} {lang.offered_virtual_gift_to} <a href={lang.path + message.receiverProfileURL} target="_blank" className="receiver">{message.receiver}</a>
                </div>
            </div>
        )
    }

}

export default ChatLogItemGift;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemGift/index.js